module.exports = __webpack_public_path__ + "img/Pyrolysis_About.4789ac3a.jpg";